const STANDARD_EXPORT_KEYS = [
  "pdf_path",
  "pdf_path_no_qr",
  "pdf_vector_path",
  "pdf_vector_path_no_qr",
  "jpg_125dpi_q85_path",
  "jpg_125dpi_q85_path_no_qr",
  "jpg_200dpi_q90_path",
  "jpg_200dpi_q90_path_no_qr",
];

const parseJsonObjectMaybe = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

const variantSortWeight = (variant) => {
  if (variant === "with_qr") return 0;
  if (variant === "no_qr") return 1;
  return 2;
};

const parsePreset = (presetKey) => {
  const match = String(presetKey || "").match(/^(\d+)dpi_q(\d+)$/i);
  if (!match) {
    return {
      dpi: null,
      quality: null,
      label: String(presetKey || "").replace(/_/g, " "),
    };
  }
  return {
    dpi: Number.parseInt(match[1], 10),
    quality: Number.parseInt(match[2], 10),
    label: `${match[1]} DPI Q${match[2]}`,
  };
};

export const getAdditionalJpgArtifacts = (source) => {
  const items = [];
  const seenKeys = new Set();
  const pushItem = ({ variantKey, presetKey, path }) => {
    if (!path) return;
    const dedupeKey = `${variantKey}:${presetKey}:${path}`;
    if (seenKeys.has(dedupeKey)) return;
    seenKeys.add(dedupeKey);
    const parsed = parsePreset(presetKey);
    const variantLabel = variantKey === "with_qr" ? "with QR" : variantKey === "no_qr" ? "no QR" : variantKey;
    items.push({
      key: `jpg_${variantKey}_${presetKey}`,
      path,
      variant: variantKey,
      variantLabel,
      dpi: parsed.dpi,
      quality: parsed.quality,
      label: `JPG ${parsed.label} ${variantLabel}`,
    });
  };

  const variants = parseJsonObjectMaybe(source?.jpg_additional_variants);
  if (variants && typeof variants === "object") {
    Object.entries(variants).forEach(([variantKey, presetMap]) => {
      if (!presetMap || typeof presetMap !== "object") return;
      Object.entries(presetMap).forEach(([presetKey, path]) => {
        pushItem({ variantKey, presetKey, path });
      });
    });
  }

  Object.entries(source || {}).forEach(([key, path]) => {
    const match = String(key).match(/^jpg_(with_qr|no_qr)_(\d+dpi_q\d+)$/i);
    if (!match || !path) return;
    pushItem({
      variantKey: match[1],
      presetKey: match[2],
      path,
    });
  });

  return items.sort((a, b) => {
    const dpiDelta = (a.dpi || 0) - (b.dpi || 0);
    if (dpiDelta !== 0) return dpiDelta;
    const qualityDelta = (a.quality || 0) - (b.quality || 0);
    if (qualityDelta !== 0) return qualityDelta;
    return variantSortWeight(a.variant) - variantSortWeight(b.variant);
  });
};

export const countMapExportArtifacts = (source) => {
  const baseCount = STANDARD_EXPORT_KEYS.reduce((count, key) => (
    source?.[key] ? count + 1 : count
  ), 0);
  return baseCount + getAdditionalJpgArtifacts(source).length;
};
